import React from 'react';

const Homepage = () => {
    return (
        <div>
            Нахмите на кнопку навигации для открытии панели
        </div>
    );
};

export default Homepage;